"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedTemplateSchema = void 0;
exports.FeedTemplateSchema = {
    "$id": "https://www.redbull.com/schemas/feed-templates.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "FeedTemplate",
    "description": "Stores a template for feeds",
    "type": "object",
    "required": [
        "type",
        "id",
        "attributes",
        "relationships"
    ],
    "properties": {
        "type": {
            "enum": [
                "rrn:feed-templates"
            ],
            "type": "string"
        },
        "id": {
            "type": "string",
            "pattern": "^rrn:feed-templates:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}$"
        },
        "attributes": {
            "additionalProperties": false,
            "type": "object",
            "required": [
                "displayName",
                "definition",
                "identifier"
            ],
            "properties": {
                "displayName": {
                    "description": "Display-name of feed (e.g. `Homepage content feed`)",
                    "type": "string"
                },
                "description": {
                    "description": "Optional description to describe what the feed-template contains.",
                    "type": "string"
                },
                "contextIdMustStartWith": {
                    "description": "Feed-template should only be applied on resources having id's that start with the specified string.",
                    "type": "array",
                    "items": {
                        "type": "string"
                    }
                },
                "contextMustBeOfSubtype": {
                    "description": "Feed-template should only be applied if context element is of subtype.",
                    "type": "array",
                    "items": {
                        "type": "string"
                    }
                },
                "definition": {
                    "description": "The actual feed template definition",
                    "type": "object",
                    "$ref": "https://www.redbull.com/schemas/system/ext/feed-template-definition/1.schema.json"
                },
                "identifier": {
                    "description": "Feed identifier such as `masonry`, `relatedFeed`, `editorsPick`, etc.",
                    "type": "string"
                }
            }
        },
        "relationships": {
            "additionalProperties": false,
            "type": "object",
            "properties": {
                "previewResource": {
                    "type": "object",
                    "description": "Resources that can be used to preview this template",
                    "required": [
                        "data"
                    ],
                    "properties": {
                        "data": {
                            "type": "object",
                            "$ref": "https://www.redbull.com/schemas/reference/localized/type-groups/content.schema.json"
                        }
                    }
                }
            }
        },
        "links": {
            "type": "object",
            "additionalProperties": {
                "type": [
                    "object",
                    "string"
                ],
                "description": "A link **MUST** be represented as either: a string containing the link's URL or a link object.",
                "oneOf": [
                    {
                        "description": "A string containing the link's URL.",
                        "type": "string",
                        "format": "uri-reference"
                    },
                    {
                        "type": "object",
                        "required": [
                            "href"
                        ],
                        "properties": {
                            "href": {
                                "description": "A string containing the link's URL.",
                                "type": "string",
                                "format": "uri-reference"
                            },
                            "meta": {
                                "description": "Non-standard meta-information that can not be represented as an attribute or relationship.",
                                "type": "object",
                                "additionalProperties": true
                            }
                        }
                    }
                ]
            }
        },
        "meta": {
            "additionalProperties": true,
            "type": "object"
        }
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmVlZC10ZW1wbGF0ZXMuc2NoZW1hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL21vZHVsZXMvZmVlZC10ZW1wbGF0ZXMuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsa0JBQWtCLEdBQUc7SUFDaEMsS0FBSyxFQUFFLDREQUE0RDtJQUNuRSxTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSxjQUFjO0lBQ3ZCLGFBQWEsRUFBRSw2QkFBNkI7SUFDNUMsTUFBTSxFQUFFLFFBQVE7SUFDaEIsVUFBVSxFQUFFO1FBQ1YsTUFBTTtRQUNOLElBQUk7UUFDSixZQUFZO1FBQ1osZUFBZTtLQUNoQjtJQUNELFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRTtnQkFDTixvQkFBb0I7YUFDckI7WUFDRCxNQUFNLEVBQUUsUUFBUTtTQUNqQjtRQUNELElBQUksRUFBRTtZQUNKLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLFNBQVMsRUFBRSxzRUFBc0U7U0FDbEY7UUFDRCxZQUFZLEVBQUU7WUFDWixzQkFBc0IsRUFBRSxLQUFLO1lBQzdCLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLFVBQVUsRUFBRTtnQkFDVixhQUFhO2dCQUNiLFlBQVk7Z0JBQ1osWUFBWTthQUNiO1lBQ0QsWUFBWSxFQUFFO2dCQUNaLGFBQWEsRUFBRTtvQkFDYixhQUFhLEVBQUUscURBQXFEO29CQUNwRSxNQUFNLEVBQUUsUUFBUTtpQkFDakI7Z0JBQ0QsYUFBYSxFQUFFO29CQUNiLGFBQWEsRUFBRSxtRUFBbUU7b0JBQ2xGLE1BQU0sRUFBRSxRQUFRO2lCQUNqQjtnQkFDRCx3QkFBd0IsRUFBRTtvQkFDeEIsYUFBYSxFQUFFLHFHQUFxRztvQkFDcEgsTUFBTSxFQUFFLE9BQU87b0JBQ2YsT0FBTyxFQUFFO3dCQUNQLE1BQU0sRUFBRSxRQUFRO3FCQUNqQjtpQkFDRjtnQkFDRCx3QkFBd0IsRUFBRTtvQkFDeEIsYUFBYSxFQUFFLHdFQUF3RTtvQkFDdkYsTUFBTSxFQUFFLE9BQU87b0JBQ2YsT0FBTyxFQUFFO3dCQUNQLE1BQU0sRUFBRSxRQUFRO3FCQUNqQjtpQkFDRjtnQkFDRCxZQUFZLEVBQUU7b0JBQ1osYUFBYSxFQUFFLHFDQUFxQztvQkFDcEQsTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLE1BQU0sRUFBRSxtRkFBbUY7aUJBQzVGO2dCQUNELFlBQVksRUFBRTtvQkFDWixhQUFhLEVBQUUsdUVBQXVFO29CQUN0RixNQUFNLEVBQUUsUUFBUTtpQkFDakI7YUFDRjtTQUNGO1FBQ0QsZUFBZSxFQUFFO1lBQ2Ysc0JBQXNCLEVBQUUsS0FBSztZQUM3QixNQUFNLEVBQUUsUUFBUTtZQUNoQixZQUFZLEVBQUU7Z0JBQ1osaUJBQWlCLEVBQUU7b0JBQ2pCLE1BQU0sRUFBRSxRQUFRO29CQUNoQixhQUFhLEVBQUUscURBQXFEO29CQUNwRSxVQUFVLEVBQUU7d0JBQ1YsTUFBTTtxQkFDUDtvQkFDRCxZQUFZLEVBQUU7d0JBQ1osTUFBTSxFQUFFOzRCQUNOLE1BQU0sRUFBRSxRQUFROzRCQUNoQixNQUFNLEVBQUUscUZBQXFGO3lCQUM5RjtxQkFDRjtpQkFDRjthQUNGO1NBQ0Y7UUFDRCxPQUFPLEVBQUU7WUFDUCxNQUFNLEVBQUUsUUFBUTtZQUNoQixzQkFBc0IsRUFBRTtnQkFDdEIsTUFBTSxFQUFFO29CQUNOLFFBQVE7b0JBQ1IsUUFBUTtpQkFDVDtnQkFDRCxhQUFhLEVBQUUsZ0dBQWdHO2dCQUMvRyxPQUFPLEVBQUU7b0JBQ1A7d0JBQ0UsYUFBYSxFQUFFLHFDQUFxQzt3QkFDcEQsTUFBTSxFQUFFLFFBQVE7d0JBQ2hCLFFBQVEsRUFBRSxlQUFlO3FCQUMxQjtvQkFDRDt3QkFDRSxNQUFNLEVBQUUsUUFBUTt3QkFDaEIsVUFBVSxFQUFFOzRCQUNWLE1BQU07eUJBQ1A7d0JBQ0QsWUFBWSxFQUFFOzRCQUNaLE1BQU0sRUFBRTtnQ0FDTixhQUFhLEVBQUUscUNBQXFDO2dDQUNwRCxNQUFNLEVBQUUsUUFBUTtnQ0FDaEIsUUFBUSxFQUFFLGVBQWU7NkJBQzFCOzRCQUNELE1BQU0sRUFBRTtnQ0FDTixhQUFhLEVBQUUsNEZBQTRGO2dDQUMzRyxNQUFNLEVBQUUsUUFBUTtnQ0FDaEIsc0JBQXNCLEVBQUUsSUFBSTs2QkFDN0I7eUJBQ0Y7cUJBQ0Y7aUJBQ0Y7YUFDRjtTQUNGO1FBQ0QsTUFBTSxFQUFFO1lBQ04sc0JBQXNCLEVBQUUsSUFBSTtZQUM1QixNQUFNLEVBQUUsUUFBUTtTQUNqQjtLQUNGO0NBQ0YsQ0FBQSJ9